import { UserRoles } from "common/enums";
import Container from "components/container";
import * as appRoutes from "config/routes.config";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AnimatedPage from "utils/animatedPage";
import ElipseOne from "../../../assets/images/app/ellipse_teacher_profile1.png";
import ElipseTwo from "../../../assets/images/app/ellipse_teacher_profile3.png";
import ElipseThree from "../../../assets/images/app/ellipse_teacher_profile4.png";
import Lines from "../../../assets/images/app/teachers/join_community_lines.svg";
import s from "../choiceProfil/assets/home.module.css";
import TypeProfile from "../choiceProfil/components/typeProfile";

const HomeLogin: FC = () => {
  //!HOOK
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const { isLoggedIn, user, isAppInMaintenance } = useSelector((state) => state.auth);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1151);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1151);
  };
  window.addEventListener('resize', handleResize);

  //!EFFECTS
  useEffect(() => {
    const isTeacher = user?.roles?.includes(UserRoles.TEACHER);
    const isStudent = user?.roles?.includes(UserRoles.STUDENT);
    if (isLoggedIn && isTeacher) navigate(appRoutes.TEACHER_ACTIVITIES);
    if (isLoggedIn && isStudent) navigate(appRoutes.TEACHER_ACTIVITIES);
  }, [auth.isLoggedIn, navigate]);

  useEffect(() => {
    if (isAppInMaintenance) {
      navigate(appRoutes.MAINTENANCE);
    };
  }, [isAppInMaintenance]);

  return (
    <AnimatedPage>
      <div className={s.home}>
        <Container>
          <div className={s.home__row}>
            {!isMobile && <img src={Lines} style={{ position: "absolute", top: "-40px", left: "30px", zIndex: "0" }}></img>}
            {!isMobile && <img src={ElipseOne} style={{ position: "absolute", bottom: "-90px", left: "30px", zIndex: "0" }}></img>}
            {!isMobile && <img src={ElipseTwo} style={{ position: "absolute", top: "-30px", right: "30px", zIndex: "0" }}></img>}
            {!isMobile && <img src={ElipseThree} style={{ position: "absolute", top: "50%", right: "60px", zIndex: "0" }}></img>}
            <TypeProfile isLogin={true} />
          </div>
        </Container>
      </div>
    </AnimatedPage>
  );
};

export default HomeLogin;
